import { FC } from 'react';
import { Icon, IconName } from 'Components/UI';
import { MenuDropdown, MenuItemStyled } from './styles';

export interface IOptionsMoreFiltersActions {
  label: string;
  icon: IconName;
  iconCustomSize?: number;
  onAction: () => void;
}

export interface IMoreFiltersActions {
  options: IOptionsMoreFiltersActions[];
  onClose: () => void;
}

const MoreFiltersActions: FC<IMoreFiltersActions> = ({ options, onClose }) => {

  return (
    <MenuDropdown>
      {options.map(option => (
        <MenuItemStyled
          onClick={() => {
            option.onAction();
            onClose();
          }}
        >
          <Icon
            icon={option.icon}
            customSize={option.iconCustomSize || 16}
            className="clearFilters"
          />
          <span className="textItem">
            {option.label}
          </span>
        </MenuItemStyled>
      ))}
    </MenuDropdown>
  );
};

export default MoreFiltersActions;
